/* eslint-disable no-nested-ternary */
/* eslint-disable global-require */
/* eslint-disable import/prefer-default-export */
// export const avatar = require('@/assets/images/avatars/black-man.jpg')
export const pdfIcon = require('@/assets/images/document-logo/PDF-icon.png')
export const wordIcon = require('@/assets/images/document-logo/Word-icon.png')
export const excelIcon = require('@/assets/images/document-logo/Excel-icon.jpg')
export const csvIcon = require('@/assets/images/document-logo/CSV-icon.jpeg')

export const users = [
  {
    id: 1,
    fullName: 'Tunde Badmos',
    company: 'Fintellia',
    role: 'super admin',
    username: 'Mary',
    country: 'Nigeria',
    contact: '070386345678',
    email: 'mary@fintellia.com',
    currentPlan: 'enterprise',
    status: 'inactive',
    // avatar: require('@/assets/images/avatars/black-man.jpg'),
  },
  {
    id: 2,
    fullName: 'Chika Eze',
    company: 'Fintellia',
    role: 'region manager',
    username: 'Dibia',
    country: 'Nigeria',
    contact: '090765455566',
    email: 'fchika8@fintellia.com',
    currentPlan: 'team',
    status: 'inactive',
    // avatar: require('@/assets/images/avatars/black-man.jpg'),
  },
  {
    id: 3,
    fullName: 'Oyafemi Benedict',
    company: 'Fintellia',
    role: 'country manager',
    username: 'Ben',
    country: 'Nigeria',
    contact: '070564777657',
    email: 'jbellany9@fintellia.com',
    currentPlan: 'company',
    status: 'inactive',
    avatar: '',
  },
]

export const headquarters = [
  { label: 'Abuja', value: 1 },
  { label: 'Cairo', value: 2 },
  { label: 'Lagos', value: 3 },
  { label: 'Accra', value: 4 },
  { label: 'Kano', value: 5 },
  { label: 'Kaduna', value: 6 },
  { label: 'Benin', value: 7 },
]
export const memoAccountActionTypes = [
  { label: 'Activate PND', value: 'Activate PND' },
  { label: 'Place Lien', value: 'Place Lien' },
  { label: 'Freeze', value: 'Freeze' },
  { label: 'Others', value: 'Others' },
]
export const memoAccountReasons = [
  { label: 'Tier Level Violation', value: 'Tier Level Violation' },
  { label: 'Suspicious Transactions', value: 'Suspicious Transactions' },
  { label: 'Expired Means Of Identification', value: 'Expired Means Of Identification' },
  { label: 'Incomplete KYC', value: 'Incomplete KYC' },
  { label: 'Court Order', value: 'Court Order' },
  { label: 'Business Gone Bad', value: 'Business Gone Bad' },
  { label: 'Others', value: 'Others' },
]
export const gender = [
  { label: 'Female', value: 'Female' },
  { label: 'Male', value: 'Male' },
]
export const llmsGender = [
  { label: 'Female', value: 'Female' },
  { label: 'Male', value: 'Male' },
  { label: 'Other', value: 'Other' },
]
export const genderList = [
  { label: 'Female', value: 1 },
  { label: 'Male', value: 2 },
]
export const categoryOfAccountOptions = [
  { label: 'Bank Staff', value: '1' },
  { label: 'Bank Director', value: '2' },
  { label: 'Other Customers', value: '3' },
  { label: 'Private', value: '4' },
  { label: 'Public', value: '5' },
]
export const sectorCodeOptions = [
  { label: 'Oil And Gas', value: '42400' },
  { label: 'Manufacturing', value: '40300' },
  { label: 'Governments', value: '41200' },
  { label: 'General', value: '41000' },
  { label: 'General Commerce', value: '40700' },
  { label: 'Information And Communication', value: '41500' },
  { label: 'Real Estate Activities', value: '40500' },
  { label: 'Power And Energy', value: '42200' },
  { label: 'Finance And Insurance', value: '40900' },
  { label: 'Construction', value: '41400' },
  { label: 'Agriculture, Forestry And Fishing', value: '40100' },
  { label: 'Transportation And Storage', value: '40800' },
  { label: 'Capital Market', value: '42300' },
  { label: 'Professional, Scientific And Technical Activities', value: '41600' },
  { label: 'Education', value: '41800' },
  { label: 'Human Health And Social Work Activities', value: '41900' },
  { label: 'Adiministative And Support Service Activities', value: '41700' },
  { label: 'Water Supply Sewerage, Waste Management And Remediation Activities', value: '41300' },
  { label: 'Mining And Quarrying', value: '40200' },
  { label: 'Arts, Entertainment And Recreation', value: '42000' },
  { label: 'Activities Of ExtraTerritorial Organization And Bodies', value: '42100' },
]
export const titleOptions = [
  { label: 'Mr.', value: 'Mr.' },
  { label: 'Miss.', value: 'Miss.' },
  { label: 'Mrs.', value: 'Mrs.' },
  { label: 'Arch.', value: 'Arch.' },
  { label: 'Messrs.', value: 'Messrs.' },
  { label: 'Dr.', value: 'Dr.' },
  { label: 'Prof.', value: 'Prof.' },
  { label: 'Chief', value: 'Chief' },
  { label: 'Engr.', value: 'Engr.' },
  { label: 'Hon.', value: 'Hon.' },
  { label: 'Capt.', value: 'Capt.' },
  { label: 'Revr.', value: 'Revr.' },
]

export const placementStatus = [
  { label: 'Active', value: 'Active' },
  { label: 'Matured', value: 'Matured' },
  { label: 'Liquidated', value: 'Liquidated' },
]

export const placementDestinationSector = [
  'Access Bank PLC',
  'Fidelity Bank PLC',
  'First City Monument Bank PLC',
  'First Bank of Nigeria PLC',
  'Guarantee Trust Bank PLC',
  'Union Bank of Nigeria PLC',
  'United Bank of Africa PLC',
  'Zenith Bank PLC',
  'Citibank Nigeria PLC',
  'Ecobank Nigeria PLC',
  'Heritage Bank Limited',
  'Keystone Bank Limited',
  'Polaris Bank PLC',
  'Stanbic IBTC Bank PLC',
  'Standard Chartered Bank Limited',
  'Sterling Bank PLC',
  'Titan Trust Bank LTD',
  'Unity Bank PLC',
  'Wema Bank PLC',
  'Suntrust Bank Nigeria Limited',
  'Providue Bank PLC',
  'Jaiz Bank PLC',
  'Coronation Merchant Bank',
  'FBN Merchant Bank',
  'FSDH Merchant Bank',
  'Nova Merchant Bank',
  'Rand Merchant Bank',
  'FBN Holdings PLC',
  'FCMB Group PLC',
  'FSDH Holding Company',
  'Stanbic IBTC Holding PLC',
  'Other Financial Institutions',
]
export const maritalStatusOptions = [
  { label: 'Married', value: 'Married' },
  { label: 'Single', value: 'Single' },
  { label: 'Divorced', value: 'Divorced' },
  { label: 'Widow', value: 'Widow' },
  { label: 'Widower', value: 'Widower' },
]
// export const eventListener = [
//   'Loan application request notification',
//   'Loan application dismissal notification',
//   'Loan application approval notification',
//   'Loan disbursement notification',
//   'Loan repayment expectation reminder notification',
//   'Loan principal repayment notification',
//   'Loan interest repayment notification',
//   'Loan fee repayment notification',
//   'Total loan repayment notification',
//   'Loan pass due reminder notification',
//   'Loan closure notification',
//   'Loan offer letter notification',
//   'Fixed deposit investment letter notification',
//   'Fixed deposit booking notification',
//   'Fixed deposit due reminder notification',
//   'Fixed deposit maturity notification',
//   'Fixed deposit pre-liquidation notification',
//   'Savings/Current account opening notification',
//   'End of Month balance notification',
//   'Customer information updates notification',
//   'Account information updates notification',
//   'Deposits notification',
//   'Withdrawals notification',
//   'Customer ID creation notification',
//   'Birthday/Anniversaries notification',
// ]

// export const entityOption = [
//   ' Customer Account table',
//   ' Customer Info table',
//   ' Loan Account table',
//   ' Fixed Deposit Account table',
//   ' CASA Product table',
//   ' Loan Product table',
//   ' Fixed Deposit Product table',
//   ' Penalty table',
//   ' Interest table',
//   ' Fees table',
// ]

export const closureReasonOptions = [
  { label: 'Customer\'s request', value: 'Customer\'s request' },
  { label: 'Regulatory requirement', value: 'Regulatory requirement' },
  { label: 'Fraud related concern', value: 'Fraud related concern' },
  { label: 'Court order', value: 'Court order' },
  { label: 'Duplication', value: 'Duplication' },
  { label: 'Management discretion', value: 'Management discretion' },
]
export const religionOptions = [
  { label: 'Christianity', value: 'Christianity' },
  { label: 'Islam', value: 'Islamic' },
  { label: 'Others', value: 'Others' },
]
export const meansOfIdOptions = [
  { label: 'National ID', value: 'NationalID' },
  { label: 'Drivers License', value: 'DriversLicense' },
  { label: 'Voters Card', value: 'VotersCard' },
  { label: 'International Passport', value: 'InternationalPassport' },
  { label: 'Others', value: 'Others' },
]

export const account = [
  { label: 'Current', value: 1 },
  { label: 'Savings', value: 2 },
]
export const accountType = [
  { label: 'Account Closure', value: 1 },
  { label: 'Overdraft', value: 2 },
  { label: 'Depreciation Expense ', value: 3 },
  { label: 'Direct Posting', value: 4 },
  { label: 'Fees In Suspense', value: 5 },
  { label: 'Due and Unpaid Fees', value: 6 },
  { label: 'General Reserve', value: '' },
  { label: 'General Loan And Lease Loss Provision', value: 7 },
  { label: 'Income Tax Account', value: 8 },
  { label: 'Interest In Suspense', value: 9 },
  { label: 'Due and Unpaid Interest', value: 10 },
  { label: 'Interest Payable', value: 11 },
  { label: 'Interest Receivable', value: 12 },
  { label: 'Interest Expense', value: 13 },
  { label: 'Provision Expense', value: 14 },
  { label: 'Due and Unpaid Penalties In Suspense', value: 15 },
  { label: 'Due and Unpaid Penalties Outstanding', value: 16 },
  { label: 'Due and Unpaid Micro Loan Principal', value: 17 },
  { label: 'Due and Unpaid Other Loan Principal', value: 18 },
  { label: 'Due and Unpaid Small & Medium Enterprise Loan Principal', value: 19 },
  { label: 'Due and Unpaid Staff Loan Principal', value: 20 },
  { label: 'Due and Unpaid Hire Purchase Principal', value: 21 },
  { label: 'Specific Loan And Lease Loss Provision', value: 22 },
  { label: 'Statutory Reserve', value: 23 },
  { label: 'Taxation Expense ', value: 24 },
  { label: 'Value Added Tax (VAT)', value: 25 },
  { label: 'With-Holding Tax (WTH)', value: 26 },
]

export const parentCategory = [
  { label: 'Asset', value: 'Asset' },
  { label: 'Liability', value: 'Liability' },
  { label: 'Capital', value: 'Capital' },
  { label: 'Income', value: 'Income' },
  { label: 'Expense', value: 'Expense' },
]

export const transactionPermission = [
  { label: 'Open', value: 'Open' },
  { label: 'Post No Debit', value: 'PostNoDebit' },
  { label: 'Post No Credit', value: 'PostNoCredit' },
  { label: 'Post No Debit Or Credit', value: 'PostNoDebitOrCredit' },
]

export const computationModel = [
  { label: 'Flat', value: 'Flat' },
  { label: 'Percentage', value: 'Percentage' },
]
export const chargeCycle = [
  { label: 'One Off', value: 'OneOff' },
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Custom - Principal repayment cycle', value: 'Custom' },
]
export const feeComputation = [
  { label: 'Flat Amount', value: 'Flat' },
  { label: 'Percentage on OD Limit', value: 'Percentage' },
]
export const camChargeCycle = [
  { label: 'Daily Cumulative', value: 'Daily' },
  { label: 'Monthly Cumulative', value: 'Monthly' },
  { label: 'Per Transaction', value: 'PerTransaction' },
]

export const feeChargeCycle = [
  { label: 'Daily', value: 'Daily' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'One-Off', value: 'OneOff' },
]

export const transactionType = [
  { label: 'Deposit', value: 'Deposit' },
  { label: 'Withdrawal', value: 'Withdrawal' },
]

export const interestType = [
  { label: 'Debit', value: 'Debit' },
  { label: 'Credit', value: 'Credit' },
]

export const accountStatus = [
  { label: 'Active', value: 'Active' },
  { label: 'Dormant', value: 'Dormant' },
  // { label: 'Closed', value: 'Closed' },
  { label: 'Post No Debit (PND)', value: 'PND' },
  { label: 'Post No Debit (PNC)', value: 'PNC' },
  { label: 'Inactive', value: 'Inactive' },
  { label: 'Total Freeze', value: 'Frozen' },
]

export const accountTier = [
  { label: 'Tier 1', value: 1 },
  { label: 'Tier 2', value: 2 },
  { label: 'Tier 3', value: 3 },
]

export const accessLevel = [
  { label: 'Level 1', value: 1 },
  { label: 'Level 2', value: 2 },
  { label: 'Level 3', value: 3 },
  { label: 'Level 4', value: 4 },
  { label: 'Level 5', value: 5 },
]

export const cardTypes = [
  { label: 'Verve', value: 'Verve' },
  { label: 'Master Card', value: 'MasterCard' },
  { label: 'Visa', value: 'Visa' },
]

export const deliveryMode = [
  { label: 'Hand Picked', value: 'Handpicked' },
  { label: 'E-Mail', value: 'Email' },
  { label: 'Postage', value: 'Postage' },
]
export const durationMonthsOptions = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
  { label: '21', value: 21 },
  { label: '22', value: 22 },
  { label: '23', value: 23 },
  { label: '24', value: 24 },
  { label: '25', value: 25 },
  { label: '26', value: 26 },
  { label: '27', value: 27 },
  { label: '28', value: 28 },
  { label: '29', value: 29 },
  { label: '30', value: 30 },
  { label: '31', value: 31 },
  { label: '32', value: 32 },
  { label: '33', value: 33 },
  { label: '34', value: 34 },
  { label: '35', value: 35 },
  { label: '36', value: 36 },
]
export const daysOptions = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
  { label: '21', value: 21 },
  { label: '22', value: 22 },
  { label: '23', value: 23 },
  { label: '24', value: 24 },
  { label: '25', value: 25 },
  { label: '26', value: 26 },
  { label: '27', value: 27 },
  { label: '28', value: 28 },
  { label: '29', value: 29 },
  { label: '30', value: 30 },
  { label: '31', value: 31 },
]

export const monthsOptions = [
  { label: 'January', value: 1, correctedValue: '01' },
  { label: 'February', value: 2, correctedValue: '02' },
  { label: 'March', value: 3, correctedValue: '03' },
  { label: 'April', value: 4, correctedValue: '04' },
  { label: 'May', value: 5, correctedValue: '05' },
  { label: 'June', value: 6, correctedValue: '06' },
  { label: 'July', value: 7, correctedValue: '07' },
  { label: 'August', value: 8, correctedValue: '08' },
  { label: 'September', value: 9, correctedValue: '09' },
  { label: 'October', value: 10, correctedValue: '10' },
  { label: 'November', value: 11, correctedValue: '11' },
  { label: 'December', value: 12, correctedValue: '12' },
]

export const yearsOptions = () => {
  const startYear = 2000
  const currentYear = new Date().getFullYear()

  return Array.from({ length: currentYear - startYear + 1 }, (_, index) => {
    const year = startYear + index
    return {
      value: year.toString(),
      label: year.toString(),
    }
  })
}

export const expiryYearOptions = () => {
  const startYear = new Date().getFullYear()
  return Array.from({ length: 5 }, (_, index) => {
    const year = startYear + index
    return {
      value: year.toString().slice(-2), // Get last 2 digits
      label: year.toString(),
    }
  })
}

export const accountTypes = [
  { label: 'Current', value: 'Current' },
  { label: 'Savings', value: 'Savings' },
  // { label: 'Virtual', value: 'VirtualAccount' },
  { label: 'Virtual Proxy', value: 'VirtualProxy' },
  { label: 'Virtual Wallet', value: 'VirtualWallet' },
]
export const cardRequestTypeOptions = [
  { label: 'Assigned Cards', value: 'AssignedCards' },
  { label: 'Unassigned Card', value: 'UnAssignedCards' },
]
export const frequency = [
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Monthly', value: 'Monthly' },
]

export const communication = [
  { typeLabel: 'SMS', value: true },
  { typeLabel: 'Email', value: false },
]

export const productCategory = [
  { label: 'Voluntary Deposit', value: 'VoluntaryDeposit' },
  { label: 'Demand Deposit', value: 'DemandDeposit' },
  { label: 'Mandatory Deposit', value: 'MandatoryDeposit' },
  { label: 'Special Deposit', value: 'SpecialDeposit' },
  { label: 'Other Deposit', value: 'OtherDeposit' },
]
export const applyInterest = [
  { label: 'Yes', value: 'True' },
  { label: 'No', value: 'False' },
  { label: 'Conditional', value: 'Conditional' },
]

export const conditionalOptions = [
  { label: 'No Of Withdrawals', value: 'NoOfWithdrawals' },
  { label: 'Balance Based', value: 'BalanceBased' },
]

export const operationType = [
  'Create',
  'Update',
  'Delete',
]

export const specifyLevel = [
  { label: 'Level 2', value: 2 },
  { label: 'Level 3', value: 3 },
]

export const parentCodeList = [
  { label: 'Asset', code: '10000000' },
  { label: 'Liability', code: '20000000' },
  { label: 'Capital', code: '30000000' },
  { label: 'Income', code: '40000000' },
  { label: 'Expense', code: '50000000' },
]

export const parentCategoryList = [
  { label: 'Asset', code: 1 },
  { label: 'Liability', code: 2 },
  { label: 'Capital', code: 3 },
  { label: 'Income', code: 4 },
  { label: 'Expense', code: 5 },
]

export const lienStatus = [
  { label: 'Active', value: 'Active' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Disabled', value: 'Disabled' },
  { label: 'Expired', value: 'Expired' },
]

export const industrialSectors = [
  'Agriculture, Forestry and Fishing',
  'Mining and Quarrying',
  'Manufacturing',
  'Real Estate Activities',
  'General Commerce',
  'Transportation and Storage',
  'Finance and Insurance',
  'General',
  'Governments',
  'Water Supply, Sewage, Waste Mgt and Remediation Activities',
  'Construction',
  'Information and Communication',
  'Professional, Scientific and Technical Activities',
  'Administrative and Support Service Activities',
  'Education',
  'Human Health and Social Work Activities',
  'Arts, Entertainment and Recreation',
  'Activities of Extra-territorial Organization & Bodies',
  'Power and Energy',
  'Capital Market',
  'Oil and Gas',
]

export const ministriesDepartmentAgencies = [
  'Nigeria Civil Defence',
  'Federal Airport Authority Of Nigeria',
  'Federal Capital Territory Administration',
  'Federal Civil Service Commission',
  'Federal Fire Service',
  'Federal Housing Authority',
  'Federal Inland Revenue Services',
  'Federal Ministry Of Agriculture',
  'Federal Ministry of Agriculture and Rural Development',
  'Federal Ministry Of Agriculture And Water Resources',
  'Federal Ministry Of Aviation',
  'Federal Ministry Of Budget & National Planning',
  'Federal Ministry of Commerce and Industry',
  'Federal Ministry of Communication and Digital Economy',
  'Federal Ministry Of Defence',
  'Federal Ministry of Education',
  'Federal Ministry of Environment',
  'Federal Ministry Of Finance',
  'Federal Ministry Of Foreign Affairs',
  'Federal Ministry of Health',
  'Federal Ministry of Housing & Urban Development',
  'Federal Ministry Of Industry, Trade And Investments',
  'Federal Ministry of Information and Culture',
  'Federal Ministry Of Interior',
  'Federal Ministry of Justice',
  'Federal Ministry Of Labour And Employment',
  'Federal Ministry of Mines and Steel Development',
  'Federal Ministry of Niger Delta',
  'Federal Ministry of Petroleum Resources',
  'Federal Ministry of Power',
  'Federal Ministry of Science and Technology',
  'Federal Ministry Of Solid Minerals Development',
  'Federal Ministry of Transport',
  'Federal Ministry of Water Resources',
  'Federal Ministry of Women Affairs',
  'Federal Ministry Of Works, Power And Housing',
  'Federal Ministry Of Youth & Sports Development',
  'Federal Road Safety Commission',
  'Independent Corrupt Practices and Related Offences Commission',
  'Independent National Electoral Commission',
  'National Identity Management Commission',
  'National Information Technology Development Agency',
  'National Insurance Commission',
  'National Pension Commission',
  'Nigeria Airspace Management Agency',
  'Nigeria Communication Commission',
  'Nigeria Custom Services',
  'Nigeria Immigration Service',
  'Nigeria Police Service Commission',
  'Nigeria Security And Civil Defence Corps',
  'Nigerian Airforce',
  'Nigerian Army',
  'Nigerian Defence Academy',
  'Nigerian Navy',
  'Nigerian Prison Service',
  'Nigerian Railway Corporation',
  'Nipost',
]

export const industrialSectorsAndCod = [
  { label: 'Agriculture, Forestry and Fishing', value: '40100' },
  { label: 'Mining and Quarrying', value: '40200' },
  { label: 'Manufacturing', value: '40300' },
  { label: 'Real Estate Activities', value: '40500' },
  { label: 'General Commerce', value: '40700' },
  { label: 'Transportation and Storage', value: '40800' },
  { label: 'Finance and Insurance', value: '40900' },
  { label: 'General', value: '41000' },
  { label: 'Governments', value: '41200' },
  { label: 'Water Supply, Sewage, Waste Mgt and Remediation Activities', value: '41300' },
  { label: 'Construction', value: '41400' },
  { label: 'Information and Communication', value: '41500' },
  { label: 'Professional, Scientific and Technical Activities', value: '41600' },
  { label: 'Administrative and Support Service Activities', value: '41700' },
  { label: 'Education', value: '41800' },
  { label: 'Human Health and Social Work Activities', value: '41900' },
  { label: 'Arts, Entertainment and Recreation', value: '42000' },
  { label: 'Activities of Extra-territorial Organization & Bodies', value: '42100' },
  { label: 'Power and Energy', value: '42200' },
  { label: 'Capital Market', value: '42300' },
  { label: 'Oil and Gas', value: '42400' },
]

export const relationshipOptions = [
  { label: 'Spouse', value: 'Spouse' },
  { label: 'Child', value: 'Child' },
  { label: 'Sister', value: 'Sister' },
  { label: 'Brother', value: 'Brother' },
  { label: 'Cousin', value: 'Cousin' },
  { label: 'Nephew', value: 'Nephew' },
  { label: 'Guardian', value: 'Guardian' },
  { label: 'Aunt', value: 'Aunt' },
  { label: 'Uncle', value: 'Uncle' },
  { label: 'Niece', value: 'Niece' },
  { label: 'Father', value: 'Father' },
  { label: 'Mother', value: 'Mother' },
  { label: 'Father-inlaw', value: 'Father-inlaw' },
  { label: 'Mother-inlaw', value: 'Mother-inlaw' },
  { label: 'Others', value: 'Others' },
]

export const customerTypes = [
  { label: 'Corporate', value: 'Corporate' },
  { label: 'Group - Joint', value: 'GroupJoint' },
  { label: 'Group - Small & Medium Enterprise', value: 'GroupSME' },
]
export const accountCustomerTypes = [
  { label: 'Corporate', value: 'Corporate' },
  { label: 'Group - Joint', value: 'GroupJoint' },
  { label: 'Group - Small & Medium Enterprise', value: 'GroupSME' },
  { label: 'Individual', value: 'Individual' },
]

export const securityTypes = [
  { label: 'Real Estate/Land & Building', value: 'RealEstateLandAndBuilding' },
  { label: 'Automobile', value: 'Automobile' },
  { label: 'Plant and Equipment', value: 'PlantAndEquipment' },
  { label: 'Natural Reserves', value: 'NaturalReserves' },
  { label: 'Marketable Securities', value: 'MarketableSecurities' },
  { label: 'Accounts Receivables and Inventory', value: 'AccountsReceivableAndInventory' },
  { label: 'Cash', value: 'Cash' },
  { label: 'Personal Guarantees', value: 'PersonalGuarantees' },
  { label: 'Post Dated Cheques', value: 'PostDatedCheques' },
  { label: 'Dormicilliation', value: 'Dormicilliation' },
  { label: 'Household Items', value: 'HouseholdItems' },
]

export const loanProductCategory = [
  { label: 'Micro Loan', value: 'MicroLoan' },
  { label: 'Staff Loan', value: 'StaffLoan' },
  { label: 'Small and Medium Loans', value: 'SmallAndMediumLoans' },
  { label: 'Online Loan', value: 'OnlineLoan' },
  { label: 'Hire Purchase', value: 'HirePurchase' },
]

export const repaymentTypes = [
  { label: 'End of Contract', value: 'EndOfContract' },
  { label: 'Pro Rated', value: 'Prorated' },
  { label: 'Upfront', value: 'Upfront' },
  { label: 'Equal Monthly Installment', value: 'EqualMonthlyInstallment' },
]
export const frequencies = [
  { label: 'Daily', value: 'Daily' },
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Fortnight', value: 'Forthnight' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Half-Yearly', value: 'HalfYearly' },
  { label: 'Annually', value: 'Annually' },
]
export const repaidFrequencies = [
  { label: 'Days', value: 'Daily' },
  { label: 'Weeks', value: 'Weekly' },
  { label: 'Months', value: 'Monthly' },
  { label: 'Years', value: 'Annually' },
]
export const interestAccruals = [
  { label: 'Fixed Method', value: 'Fixed' },
  { label: 'Reducing Balance Method', value: 'ReducingBalance' },
  { label: 'Reducing Balance But Equal Method', value: 'ReducingBalanceButEqual' },
]
export const periodPenalties = [
  { value: 1, label: '30 days after penalty start charging' },
  { value: 2, label: '60 days after penalty start charing' },
  { value: 3, label: '90 days after penalty start charging' },
  { value: 4, label: '180 days after penalty start charging' },
  { value: 5, label: '1 year after penalty start charing' },
]
export const penaltyCharges = [
  { label: 'Continuous', value: 'Continuous' },
  { label: 'Discontinuous', value: 'Discontinuous' },
]
export const securityDeposits = [
  { label: 'Required', value: 'Required' },
  { label: 'Unrequired', value: 'Unrequired' },
]
export const securityDepositTypes = [
  { label: 'Flat Amount', value: 'FlatAmount' },
  { label: 'Percentage on loan amount', value: 'PercentageOnLoanAmount' },
]
export const limits = [
  { label: 'Limited', value: 'Limited' },
  { label: 'Unlimited', value: 'Unlimited' },
]

export const cardStatusOptions = [
  { label: 'Active', value: 'Active' },
  { label: 'Generated', value: 'Generated' },
  { label: 'Blocked', value: 'Blocked' },
  { label: 'Hotlisted', value: 'Hotlisted' },
  { label: 'Expired', value: 'Expired' },
]
export const cardRequestOptions = [
  { label: 'Assigned Cards', value: 'AssignedCards' },
  { label: 'Unassigned Cards', value: 'UnassignedCards' },
]
export const requestOptions = [
  { label: 'Assigned Cards', value: 'Assigned' },
  { label: 'Unassigned Cards', value: 'Unassigned' },
]
export const batchCardStatusOptions = [
  { label: 'Generating', value: 'Generating' },
  { label: 'Revoked', value: 'UnassignedCards' },
  { label: 'Generated', value: 'Generated' },
]
export const cardGenerationStatusOptions = [
  { label: 'Pending', value: 'Pending' },
  { label: 'Processing', value: 'Processing' },
  { label: 'Processed', value: 'Processed' },
  { label: 'Failed', value: 'Failed' },
  { label: 'Cancelled', value: 'Cancelled' },
]
export const securityQuestions = [
  { label: 'What is the middle name of your youngest child?', value: 'What is the middle name of your youngest child?' },
  { label: 'What was the name of your first stuffed animal?', value: 'What was the name of your first stuffed animal?' },
  { label: 'In what city or town did your mother and father met?', value: 'In what city or town did your mother and father met?' },
  { label: 'What is your oldest cousin\'s first name?', value: 'What is your oldest cousin\'s first name?' },
  { label: 'What was the first exam you failed?', value: 'What was the first exam you failed?' },
  { label: 'Who is your hero?', value: 'Who is your hero?' },
  { label: 'What is your child\'s proudest accomplishment?', value: 'What is your child\'s proudest accomplishment?' },
  { label: 'What did you want to be when you were small?', value: 'What did you want to be when you were small?' },
  { label: 'What does your youngest child want to be when he/she grows up?', value: 'What does your youngest child want to be when he/she grows up?' },
  { label: 'If you could only eat one meal for the rest of your life, what would it be?', value: 'If you could only eat one meal for the rest of your life, what would it be?' },
  { label: 'Who is your favorite author?', value: 'Who is your favorite author?' },
  { label: 'What was the worst nickname your friends called you in your elementary school days?', value: 'What was the worst nickname your friends called you in your elementary school days?' },
  { label: 'Who is your celebrity crush?', value: 'Who is your celebrity crush?' },
  { label: 'What was the name of the boy or girl you first kissed?', value: 'What was the name of the boy or girl you first kissed?' },
  { label: 'Where were you when you had your first kiss?', value: 'Where were you when you had your first kiss?' },
  { label: 'In what city did you meet your spouse/significant other?', value: 'In what city did you meet your spouse/significant other?' },
  { label: 'If money was not an object, what would you do all day?', value: 'If money was not an object, what would you do all day?' },
  { label: 'If you could go back in time, what year would you travel to?', value: 'If you could go back in time, what year would you travel to?' },
  { label: 'What is the worst gift you have received?', value: 'What is the worst gift you have received?' },
  { label: 'What\'s your favorite zoo animal?', value: 'What\'s your favorite zoo animal?' },
  { label: 'Who was your first crush?', value: 'Who was your first crush?' },
  { label: 'In what city were you born?', value: 'In what city were you born?' },
  { label: 'What is the name of your favorite pet?', value: 'What is the name of your favorite pet?' },
  { label: 'What is your mother\'s maiden name?', value: 'What is your mother\'s maiden name?' },
  { label: 'What is/was the make of your first car?', value: 'What is/was the make of your first car?' },
  { label: 'What is/was the model of your first car?', value: 'What is/was the model of your first car?' },
  { label: 'What was your favorite food as a child?', value: 'What was your favorite food as a child?' },
  { label: 'Where did you meet your spouse?', value: 'Where did you meet your spouse?' },
]
export const category = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
]

export const lendingModel = [
  { label: 'Credit Unions', value: 'CreditUnions' },
  { label: 'Individuals', value: 'Individuals' },
  { label: 'Neighbourhood And Small Group Revolving Funds', value: 'NeighbourhoodAndSmallGroupRevolvingFunds' },
  { label: 'Other', value: 'Other' },
  { label: 'Solidarity Groups', value: 'SolidarityGroups' },
  { label: 'Staff', value: 'Staff' },
  { label: 'Village Banking', value: 'VillageBanking' },
  { label: 'Wholesale Lending', value: 'WholesaleLending' },
]

export const batchAccountFormat = [
  {
    title: 'Mr',
    lastName: 'Ezeka',
    firstName: 'Chidiebere',
    otherNames: 'Sunday',
    referenceNumber: '10035',
    gender: 'Male',
    address: 'No 1 Falade close, haruna street',
    maritalStatus: 'Single',
    maidenName: 'Mary',
    religion: 'Christianity',
    signatureFileUrl: 'https://upload.wikimedia.org/wikipedia/commons/3/3a/Jon_Kirsch%27s_Signature.png',
    passportFileUrl: 'https://www.seekpng.com/png/detail/428-4287240_no-avatar-user-circle-icon-png.png',
    phoneNumber: "'08071836453'",
    email: 'chidiebere.ezeka@example.com',
    hometown: 'Ogba',
    dateOfBirth: '1987-07-20',
    nationality: 'Nigerian',
    state: 'Lagos',
    lga: 'Ikeja',
    meansOfIdentification: 'NationalID',
    idNumber: '102876373657211',
    nokName: 'Cynthia Ezeka',
    nokAddress: 'No 2 Falade close, haruna street',
    nokGender: 'Female',
    nokRelationship: 'Sister',
    nokPhoneNumber: "'07010959282'",
    nokEmail: 'cynthia.ezeka@example.com',
    occupation: 'Employed',
    employerName: 'Mr Jonah',
    employerAddress: 'No 3 Falade close, haruna street',
    officePhoneNumber: "'09087657374'",
    accountName: 'Ezeka Chidiebere',
    accountType: 'Savings',
    accountStatus: 'Active',
    branchCode: "'002'",
    productCode: '220',
    accountOfficerStaffID: '676548',
    accountTierLevel: 1,
    accessLevel: 1,
    enableEmailNotification: true,
    enableSMSNotification: true,
    statementDeliveryMode: 'EMail',
    statementDeliveryFrequency: 'Monthly',
    minimumBalanceRequired: 1000,
    accountCreationChannel: 'Banking Channels',
    referee1CustomerID: "'00000086'",
    referee2CustomerID: "'00000094'",
  },
]
export const batchLoanFormat = [
  {
    customerID: "'0000227'",
    linkedNumber: '1000001688',
    referenceNumber: '1001',
    productCode: '305',
    lendingModel: 'Staff',
    economicSector: 'General',
    guarantorID1: "'00000086'",
    guarantorID2: "'00000094'",
    penaltyGracePeriod: 10,
    loanAmount: 500000,
    interestCommencementDate: "'2021-12-16'",
    hasCollateralPledge: true,
    collateralType: 'Cash',
    collateralValuation: 2000000,
    collateralDescription: 'Toyota Corolla, 2014',
    startDate: '2021-12-15',
    principalRepaymentType: 'Prorated',
    principalFrequency: 'Monthly',
    principalToBeRepaidEvery: 30,
    principalInstallment: 5,
    applicableInterestCode: "'022'",
    useProductInterestRate: true,
    applicableInterestRate: 20, // percentage
    defaultingInterestRate: 10, // percentage
    interestRepaymentType: 'Prorated',
    interestFrequency: 'Weekly',
    interestToBeRepaidEvery: 7,
    interestInstallment: 5,
    interestAccrualMode: 'Fixed',
    interestFreePrincipalAmount: 1000,
    securityDeposit: 100000,
    holdFundSecurityDeposit: true,
    accountCreationChannel: 'Banking Channels',
    loanFeeCodeSeparatedByComma: ["'008', '004'", "'006', '002'"],
    // allowMoratorium: '',
    // moratoriumEffect: '',
  },
]
export const batchLoanDisburseFormat = [
  {
    'Loan Account Number': '',
  },
]
export const tableAllHeaders = [
  { key: 'accountNumber', sortable: true, label: 'Account Number' },
  { key: 'referenceNumber', sortable: true, label: 'Reference Number' },
  { key: 'message', sortable: true, label: 'Message' },
]
export const tableLessHeaders = [
  { key: 'referenceNumber', sortable: true, label: 'Reference Number' },
  { key: 'message', sortable: true, label: 'Message' },
]

export const economicSectorModel = [
  { label: 'Oil and Gas', value: 'OilAndGas' },
  { label: 'Manufacturing', value: 'Manufacturing' },
  { label: 'Governments', value: 'Governments' },
  { label: 'General', value: 'General' },
  { label: 'General Commerce', value: 'GeneralCommerce' },
  { label: 'Information and Communication', value: 'InformationAndCommunication' },
  { label: 'Real Estate Activities', value: 'RealEstateActivities' },
  { label: 'Power and Energy', value: 'PowerAndEnergy' },
  { label: 'Finance and Insurance', value: 'FinanceAndInsurance' },
  { label: 'Construction', value: 'Construction' },
  { label: 'Agriculture, Forestry and Fishing', value: 'AgricultureForestryAndFishing' },
  { label: 'Transportation and Storage', value: 'TransportationAndStorage' },
  { label: 'Capital Market', value: 'CapitalMarket' },
  { label: 'Professional, Scientific and Technical Activities', value: 'ProfessionalScientificAndTechnicalActivities' },
  { label: 'Education', value: 'Education' },
  { label: 'Human Health and Social Work Activities', value: 'HumanHealthAndSocialWorkActivities' },
  { label: 'Administrative and Support Service Activities', value: 'AdminstrativeAndSupportServiceActivities' },
  { label: 'Mining and Quarrying', value: 'MiningAndQuarrying' },
  { label: 'Activities of Extraterritorial Organization & Bodies', value: 'ActivitiesOfExtraterritorialOrganizationAndBodies' },
  { label: 'Arts, Entertainment and Recreation', value: 'ArtsEntertainmentAndRecreation' },
  { label: 'Water Supply Sewerage, Waste Management and Remediation Activities', value: 'WaterSupplySewerageWasteManagementAndRemediationActivities' },
]
export const repaymentOptionForDailyAndWeeklyHoliday = [
  { label: 'Do not move schedule', value: 'DoNotMoveSchedule' },
  { label: 'Move schedule forward to next working day', value: 'MoveScheduleFoward' },
  { label: 'Move schedule backward to prior working day', value: 'MoveScheduleBackward' },
  { label: 'Move schedule foward by current frequency and increase loan duration', value: 'MoveScheduleFowardAndIncreaseDuration' },
]

export const repaymentOptionForOtherFrequencyHoliday = [
  { label: 'Do not move schedule', value: 'DoNotMoveSchedule' },
  { label: 'Move schedule forward to next working day', value: 'MoveScheduleFoward' },
  { label: 'Move repayment backward to prior working day', value: 'MoveScheduleBackward' },
]

export const classificationLists = [
  { label: 'Performing', value: 'Performing' },
  { label: 'Pass & Watch', value: 'Pass & Watch' },
  { label: 'Substandard', value: 'Substandard' },
  { label: 'Doubtful', value: 'Doubtful' },
  { label: 'Lost', value: 'Lost' },
]

export const moratoriumType = [
  { label: 'False', value: 'False' },
  { label: 'True - Principal only', value: 'PrincipalOnly' },
  { label: 'True - Interest only', value: 'InterestOnly' },
  { label: 'True - Principal&Interest', value: 'PrincipalAndInterest' },
]

export const moratoriumEffect = [
  { label: 'Increase total loan duration with the length of moratorium', value: 'IncreaseTotalLoanDuration' },
  { label: 'Do not increase loan duration with the length of moratorium', value: 'DonNotIncreaseTotalLoanDuration' },
]

export const reportDataDetails = [
  {
    orgLogo: 'data:image/png;base64,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',
    orgName: 'Fintellia Microfinance Bank Limited',
  },
]

export const reportDataDetail = {
  orgLogo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACMCAYAAACeTFAfAAAVCHpUWHRSYXcgcHJvZmlsZSB0eXBlIGV4aWYAAHja7ZpZdiO9DYXfuYosgTPI5XA8JzvI8vOBJdmSLQ/9dx7TarvkGjgAFxcXZJn1n39v8y/+ia3FxCQl15wt/2KN1Te+FHv9q+e3s/H8vk7l2zX3fN6UcbvgORU4hutPabf7G+fT+wP3Plx/Pm/K7Yovt4bcW8PnX9Ce9ft8HCTn/XXexVtDdV1fci3yONR+a2jcbjxDuf3Et2FdB/3bPJ0QrDQTHQXvV3DBnt/xGkHQHx8aR8dvF5zXb5HvMXjDIYX7SDDI0/TuR2sfDfRk5Ps389H6a702vm+3O8IHW968aPjy8oJLH86Ht/79Y8fhbUT++UIJrn2azu1n71n2XtfsWsxYNN8QdYzt7s1wY8fk4TyW+Qg/ie9yPpVPsc0OXD7tsJ3PcNV5vLKNi2665rZb5zjcYIjRLy8cvR8+nHMliK9+hMtPfNz2EmqYoeDJ4ZcJQZ33NhZ3+q2nv+EKPU/Hrd7RmDvu/+Jjvrv4Jx+ztwabc2pMXO8uB3vFNcNQz+lv7sIhbt/8lo6B75+b++0DsIAqHkzHzIUJNtuvJnpy79gKx8+B+xLHK4SckXlrABPRd2IwgD86m11ILjsr3otz2LHgoMbIfYi+4wGXkp8M0scQsjfii9e+eUbcudcnn72ehptwRAo5CL6poeGsGBP4kVjAUEshxZRSTpKKSTW1HHLMKecsWUmuSZAoSbKIFKnSSiixpJKLlFJqadXXAAemmqvUUmttzZtGR422Gvc3znTfQ4899dyll157G8BnxJFGHjLKqKNNP8OEJmaeMsussy1nFkyx4korL1ll1dU2WNthx5123rLLrru9ee3m1U+fP/Cau3nNH0/pffLmNc4akXsTTukkqc/wmI8Oj4t6AEB79ZktLkavnlOf2eoJiuQZZFLfmOnUY7gwLufTdm++e/fcr/xmUvmV3/xPnjPquv+F5wyu++y3F16bSnfjeOyKQrWpDUTfFmm+GH6s5ddvj2PZHKeE3tYuDHVjKigrmhg35l1ETi97bJuLDXmttf1cA5asbeWUCulxrFTwA+ALSQDbKDkHt+qoJaZgylxzxs0QQ1uppzBz25JyHaMKDgYDzVt4ms6Z3dohFlrpUivWaIkGMW0spk5aXzXNmfocw4kAkTxXitXZjaNDdUkHobevjmVb4LbGHT4xQSjYMhUxDSEgPSaXilJ3aW30VKLF1dBDGTm52nd1C/T1DYyT4+bPR/PVhd8fU+6zL9NlBqzUpNeqaaOor30bbkof4LQCMAacd6lrCVqm+NZk7orJktSRud7mzKZ1CUuwd8Vr2c0qq+6q842JJvHF8iCFPjFuc4VY2UrqjsOEU1dPo/QQTOiOuPBjCKgXH6c/A7auhuIGzsa2fi/HiPuesbkKOHDMGqH4VEv3u4nD2Gl1zjdkUtp2IgSJKrzR41zNroxnNAdOWR3vzZJ7Wh7xNEF3CuIwSNm2u2YIbKdhEaUBOnFCxGxb+qDJiokI3N0bPod9sI5llGsO6QmYjDZQZ6OluJsB0qvv5ncZPW7QSOCNxYhj8pUmVLkFbASTzQTNEP0ZU0Y/cuwDlvKgj5A3pbrDgWHIVkW7fQeKpH67Xe9eaYg+UYWQSmpWyvKwwqx5t7JyPFpWucnADwW/1jEJOUaZIBJcTFAUuEVjm7jpvXhcmiqAjtqDwnl5iGc73NNT7WZMt2QHP1uEJLZUjQuwtFJaUKKTE+IpgzEuVahyhtyRRdwkkI3GX4HGDASh2rj902NEA8F0niyyId7RiMcVYEV19nCIZSAUmOwOJTH5AG6jdROQrCbgPQ+fE86vTtWuiwYZBAPatoPywMDfqZWaix8wc567ZeFGQnYt1Etnjqu5VicwQ2iBTiX6ANUK/gmLAKrAiKSRyqIgARgVWz/NY2egVwnW5UDHrDDDzHCwLRNhaDZZzPYSOUoFNHn7NFW8FR0B0RYbvGfBWSWi8dz0i2jMyy5CnLFAtnuMaUSzQFNgNNpfSeHFI3WBvAEVqMalE9JKFbJLBys+7M5lDr7tBDY2AWiI1Ei4JqAAs3o3O8KUk5BmraIUTNfQIWQ48ooj7DW654qGPVxLPEMdIZp8bo61kHYyg2wg0du9YlzkDSRUFufH9lEFM8MisZHOwj2tQGukVrBvRoplkQYOe8Bmq8CquR9zktYYQweidutTNB8I2cS8CJeSlGMsLp40ZqrDQ8gHzDGJR+6aOFn6nJ4U4VMbY5AVlKwyOLncN5sHQtMeDpWGiYtObY45HDiH1ghgQq6tSliTQdz4Lc6rcbUyqa6FIrLBkx9dhuaQA5DxqmKVEjN1ROg2TOitHzInm8Mm6CdiMNfuiplq3AZqRu7YlBsIjQSyMmSfqSUWLFZuHDP3FCFDSW2V+GnUONUBmlmtGZDoWEz5u/FrmGlm8Th3jIat7UKhKXcHYqj0nUyeqGoPh/is5U3Og/JXlhJZ67NETMzYxbVo1ahTCyT4FrWNKiTPeBJ1hFGNV9bBNQAR5oTTYFfgfwqfsFU8qKujwKJKcMzE0/5WYbBVZDjZtYY0DTw8ywgNrRRBBEhT/e0VL/g2kPYrPEaze2j6yAUGVPJDqNbDfqSKtol+DJVIMzIag8AUZDDZGWW2NolVu7XKrmoJMmrCm/QA4RMh9OdJrbCvrASysyRdB9Bc/n60p2ZDOHrPXKeVi6mkJtjbImnsYkZEHTEH7pI3B6piZ9jJkR0iI8zCXJBLlXtwPhCfgJ56I5PdkJpzWLJATr5MpoiNprRgVknghsQaQx5BckygQXpXgG6yUldzJ0QwlSkVpT8hLUD4gzAxRHchScNhOBGhikc6pWsLUGnRu0j4G47x0xP9PgEjDKkW9QrSHQRBOdI20puidCgfFRgLi0LiQ6zvVqVkRowsuaSkVBI2VIW+X2GSv3XhoiEiV4/m2cZfHVEAyL+t1TKyGKfu7skMcGSsMDwDM1woC0nTsBvmlzhgEmgbSYFULEQb2ZAhNiZMNqeEUAkQ4RuwPSLas1NuUkKoWLpIBpOjFUIcjgStVQuhHuDFDv5gBiSXCxn5RNHQZp91OOaKVC2WOKLuV0LDDGQg6iCECQIJxFYVCwnJrc1htK1LOQSAAsxreoC8OB/eTPCljYgAkmF0qhbemTgctJBMph+USgKbLUwFWZnaIbbTrfNoLaAFT7WuJQ6Mhtd7xJGElSPValjBJ526C8oeCyiSqEBhW0YDds1MFaeBtrT8stM1QhSGJGlNJNYIzMkPfEfxsDQNoN6hzwW/0RhKJmwTVUnCngkhofkHUCxURFAvked8zJ0MS14fmB4WTEmXJch/iB1ql07DSAbfDZY+TiNvYlDUPqpJv5GVSevnnD5qYcXOLWhyks7WOSLccopO1zBbmAbbpwhxoLf3rmtDVHPnMzYGvBx8SqJBiVM/6N9RXo1nJgNzBzSFVkeTaOCIhGYMmPzk4N+2ba7GqcYem7+1zoyv1h/b/qJl85th/2bU5vcm+X7U5jfD/r+x/2/s/5Gx0+dRx9LQwBS5UXOmiV63BUTT3edGGkJkIyZJN3FAZcgeT22XZVLlaWZBVSgJUaoamSqkqOosjaBJKOSdaKamynsp4chpJOxODWwTGSo4qB2tYSgVmVdascNkqMhNIQuzIWqgLyg3lU09v6ntKTHVAoMapsB5livkL6rGgS7G/cxYttWlAveyKTJn+vjUWX7aF3/eHjMXrfZDr9ezmsGQDFQeDVWnut5mChNSj/WNGmy5QbIgGU+1iadAJ/1TZqlMTOGH/l53V+ypojcdIbTIM7rygSBYQrl9nLvVZ/l5Nu8mSLqm9vExQuTVU49jUp18yo+lyzOuoOd60MIsTNu0hAJFHRHxxxNCKuH8GRE3wZ9VNB9jMwilPMh6IKR/97gmNDnnwpaTAxHMzCugkBVepr92+v2566n3Z9DSoBFVoYkR0aMzE7WKeWHM1033cjk+I7VI+hoEnSLKaQcqIjTwqD+Gykw/XUBoTl13/qNxMjdDxYVg74NCCn8+jUxQgiVVaoZNhCEuCHmq/YjUigCzacvzqky8HGR7EFu7fktD4yGP+f1Sn2OaXsfrRNebwA8VpC7Nt53tV7HpEqKkJBnUNbMLY1yZOmx0V89ysJeCAvOG4UMrWZCW1keKod5BHZ1TfqK9C2Wh/um6EHSVU9eukitIMq0EsDp0h/K/ZDRVlU9YIuGImQc8FmvPC9QlShAkOhGF+CVEaw6ilVhBK1LuKztqkZsM3UsZzcUSRlTVpQWirvQAvHnGUlS6pkDh7v0iTkJBZGqtwAAkrRMLtplBsUxFQ01M0eRChQxWzMGi4ZVLOzoSVckUim4Cp8DdqUDvOhFf3NDaB2Bng0KkiKZw9FqMQ9dE0HLAl3HC7DlAQ9QoMJAFbVgHBFMyROrX2Qp1AeUusIkm0qYuv/mKK+opIXvUdnS3qbdada1VMp7Folpsz46QTjMNT81ANS+iZpgmH5cxGtyV0cVa2iYtBUdYGfymBqjxVF5aalMT4CREtC4iIIY94E269tPM2SCVDDUL5bQuJmFeaiuor0grSy3VxkHhim5RE1kEeuyLMstRlMxdIRSJRosZysyF9A69J8qRYtMuzHYU13WFghZ8JyJ111zNkykAiLdRWm+6NCa6uBoM3SaBS8pZ918I/xl0lakoycz6w75EcFSPh6WM9zsRrQcNnvyGVRau+RBJVyBxR9elQbdvEcpcdi+H50nZmh3Pyq9iS9nRJQ8/kJX1r+aUPOd4G8pZxNDErmwOjVD7bqZt6CNjAi1jw21Uidtw/Gnm/F9CxU6df64TZvSyqIQRFvEiZluGgeH22YgQxVXaLZEc/dtXjX53sZRbOhgM3CLeZD4FkqPNeeoq9JGcOTo1/94g7fRRW8loka63Y/kzuqUbf0OX+CgBFXwLO1oI5dgIgEGlJXaIHTsDYbKUrsp13ZcWQpdqyE8d73uBCSGVoXelWfu6GiI2sF8AnWO7eqit66KAXsxJHSGQ0zcgwfJKuOZi3L8nXPOIk28J94YP8vEjPhQd2wMKo7aVA/iKfZamHV0PZkDrbQDqHPUTRNWuDCzolx1P8/xEkpKpOjTkIUJVd8dU4xzqvYFEIXIQQhIEIWe4MZ+REdLQR6eER6BO42uu7vrOV4XuM0ao+OMF1SGK20WWZXp2fYCGuWMDB83rdo09HJ+YSs5nGXp1SHPrYGAa7LLUGNFDRNDsDmQrcv8F+3nWlctRHtPWrAN+iHGUeU6XZ8nom6/w3yRvXNlYIWXeMHUHlK6uvyXiz7AgHeoG4RpnHUg9KJGpNAMX6vZl/mFhd8TXwBCkQ+nhjEjt1Zz6to9rwWKfadgznkdc6LR5nnwr7Si7cMN57PbS2cedBJzurcrbYL4lF5T8GzVpd+aJnXSWdTwDRlo7iy2B22BBxtmn8gYEtXUXrcYeS93m/h1TfsKLbq2rzCJZnWDFrPwiVbwAilGkoFP1dl3JBgTteCiEdMomqP2BV7DSYRal4ItbpJbDTOadmp6Y6THG3dJ3ZojxrNtcas0B542i278XwICXufClmedCmMLzFU6ACU59TGzHoye16TiNOyoq/LAOmf2Flo9gAbdXYvPmLa1dSe2whu7PMpoLIPjtmrLO5vu8pkOq9yFc7PKCXAQF8JGYDi0RU7p8aN1YH2GS0os8pmueRHsvVNIttfj+VWXYIbZHnKBpLqzutzSmVXn4CiDxZDNymZETQyednWTGY1TaEAxWe2CXO7eg7F9zkznk9BDl9qukhL/qAZSqgxuk7oBC8ZivkXFkz2NC+1bzmPsXChtPAYeuJ1RbC7p9dV5JRDriG92UsbdKDn+v3d1ZdJzlqq7CRSNTe9BgpC5AtVE+5461WqlON1EYGOd60VInyWyKpU2gX4sb80rZRZfE0889vne4dYvzU4Pm3qJu8Oq2wc4uZPznuK8CMYuMRzqj89XgAKJdL4fM1iFOrdz0hbydjS6DvxiNdcqU0N3HB7663/BAL2k7j2PIhuApdU0nUzePYlyas5cKY76AlNw0M/aUx1Xwu/siEIrtc59AWSWDSzt3QBf0zR7tGFwgtJtAcZajvsND2UOvqVWDbytoobQiwjXbvjRxeB6EDoFwwMElkf/JM01j7dcPguNIJlhegIhWavmsXp/nzS8aoK6Gswr8Xc7GZnUZn89GsUxZtaaW1N30a+kdFGTMQkC0sxJ35Qliu53oehr0ix4Pjk6n+o4JVbnuBetqivg0kureHHLR/Xk/SyXllTCHRueavj0bxfxklY8PfHW/uR4g9VqSUFj6vkDUXUcwHQtCSygbIWwty5Z9wIQuJb6jgqkBjD6dfB7PG8DO+oy91mduIBNtcK3HBs2CQZUsIa+Smkuk7yYZYPFBSQb0K2DJU18UCASH/wJn5p9YRj7fXw3ak0Ib3tfdf2n6RqadQYvztjKqJo5Rl75S5lssQfdHVeRyUd91DVCBk6Rb5EbAGGXq8I1yd850CY6U9U1vffF5XglTUUXR1JwOkSS467V/UzGI7t8QtLLSVfgiFoovCpMj8zUlPdx47tP12+fWFPda41BlP3TLo6+6tff2rL23+Lln0/frW7/p/OWUzVdz/tMpm990+5spm2+6/qMpmz9181f9mj9181dTNn/q5q+mbP7UzX+E7FOMnK3NiPS5UqFHnvmzC+JoXFmZUN2jqcxYznsTEVV5ng1lWpGlm+CruS4l256Kvh2YkIIh6lHVc9PXZeS8RkkihYdXRn0gtHSlcOnaWxGI0HddoqtKF+lohCvTk+0SV3T5i9a37RMWDbptHFfSdzyGEXghnbpOX6MaUES86uh53oUK8rlJ168V+afz5n6hTx8OI6uaRdIqGzPas+mzVfNygyaqU4pRLkCWombe6VpHNvm2vPx8+pzdsVw7x6KvjVBvReVEXe8+S5hHYd+nIOblDM5S9IsZvJ//NAHzuxloJkn3lf78tgvwcM08XzyzeZqLqp9rNt87w/zkjd86w/zkjd86w/zkjd86w/zkjd86w/zkjd86w/xtaNzPm78NjbszzN+Gxn0C5m9D4z4B87ehcb9m/jY0PvHRPw2N+1TM34bG3RnmH4ZGp7ChFJcURm01TmdiDbGs2i0KFlG+pCCE9X3ZFxbLLZeu+x5hOp/QelOXorIrA2Kr5x1TXQ/EYP8FN+xrDvSO/0EAAAGGaUNDUElDQyBwcm9maWxlAAB4nH2RPUjDUBSFT1OlohUHO4g4ZGidLIiKCC5SxSJYKG2FVh1MXvoHTRqSFBdHwbXg4M9i1cHFWVcHV0EQ/AFxdHJSdJES70sKLWK88Hgf591zeO8+QGhUmGp2jQOqZhmpeEzM5lbFwCt86EMQs4hIzNQT6cUMPOvrnrqp7qI8y7vvz+pX8iYDfCLxHNMNi3iDeHrT0jnvE4dYSVKIz4nHDLog8SPXZZffOBcdFnhmyMik5olDxGKxg+UOZiVDJZ4iDiuqRvlC1mWF8xZntVJjrXvyFwbz2kqa67RGEMcSEkhChIwayqjAQpR2jRQTKTqPefiHHX+SXDK5ymDkWEAVKiTHD/4Hv2drFiYn3KRgDOh+se2PCBDYBZp12/4+tu3mCeB/Bq60tr/aAGY+Sa+3tfARMLANXFy3NXkPuNwBhp50yZAcyU9LKBSA9zP6phwweAv0rrlza53j9AHI0KyWb4CDQ2C0SNnrHu/u6Zzbvz2t+f0AusZyxAnjWDMAAAAGYktHRAD1ANIAAPeahQwAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAHdElNRQfmAQsNKjneHiv9AAAR80lEQVR42u2d61PU1R/H3+e7311ARAFB7pqX5KKjYV4Aw8wpVFBRRy3GmqaZZkSf96B/oEdNjfnAnKyZamTGtJSbSlkaoGYqgoiKgqSiyEWRy7Ls7vfye+Cc72+XBfbCLizL5/2kVNjLOa/v53Y+5xxmMplUkJyKMQYAUFUaLlck0hCMLlVV0dzcjJaWFkiShNjYWKSmpiI4OJgGZ7QHkSzWyBaqu7sbJSUlePr0KSRJgqqq0Ol0AID3338fCxcuJAtGYLlnpa5du4Y//vgDqqpq8HB3yBiDLMtISUnBli1byHoRWM7V2dmJ0tJStLW1QZZlMMbAGIMgCBpgqqqCMQZVVWEwGLBlyxakpqbS4BFYw1upyspKVFZWQqfTObg4DtNwUhQFycnJ2Lx5M6ZNm0aDSWC9Unt7O06dOoWOjg7NQrkDpK02bdqElStXQlEUAmuqfnlZlnH58mVUVFQgJCTE7u8FQfDo9QRBwGuvvYZNmzZh1qxZBNZUy/iePHmCkydP4uXLly65OkEQIAgCJEmCKIpOLZIkScjPz8eyZcvcsoAE1iSVJEmorq62i6VUVR3RQvF/UxQFkiRp5QZnFo3DmJiYiC1btmDWrFlTqjQxpcB68uQJjh07BpPJpGV1zoJzRVHAGENSUhKys7PR2tqKCxcuaICNFnvx92CMYcOGDUhPT3f6ewTWJJLVasWZM2dw8+ZNzRW64i45eIqi4LPPPkN4eDgURUFRURHu3bsHWZaHzSCHs3gAEBUVhe3btyM6OjrgwRIC/Qs+ePAA33zzDerr6yHLskdlCFVVMX36dO3vwsLCIEkSBEFw+pq8mKqqKjo6OnDkyBFcvHgx4N1iwFosbqVqamqg1+vtYqXhLBa3UNwK8cp6ZmYmEhISEBISov2exWJBZ2cnGhsb8ddff2lWi7/2SG7V1gpGRkZix44diImJIbAmS8bX0NCA3377DaIoumylbGEQBAEffPDBqNV0Dkh/fz9Onz6Nuro6DTBXXK0gCDCZTMjJycHq1auh1+sJLH+VyWTC77//jtraWoii6BCgOwMLAIKDg7F3715ERUU5zRZt/3vhwgWcO3dOW/5x5f0EQYDFYkFcXBw2b96MxMTEgHGRAQGWqqq4f/8+jh49CoPBAMbYiC7PmcXat28f4uPjHQCyWq3o6emBIAiIjIwcNqs8deoUamtrXYKDx2680i/LMjIyMrB27dqAWNSe9GD19/ejrKwM9+7dA2PMpeLlSFqxYgW2bt1qB6SiKKivr0dJSQlMJhNUVUViYiIKCgoQERFhl2UODg7iyy+/xODgoNtQ80Rg+vTp2LFjB+bOnUtZ4URIURTcvn0bBw8eRFNTE3Q6nUtZ2mjBfnZ2tl2bDADcunULv/zyi1YcZYyho6MDhw8fhsVisQPIYDAgKyvL7Uo7t1iiKMJoNOLnn39GeXk5LBYLgTWe6uvrw48//ohff/3VwTp5snzCGEN4eDhmzpxp14IsyzJOnTqlLeXwRj9JkmA0GlFfX+/wOnPnzoXZbHZ/ImwyVsYYamtrcfDgQdy/f5/AGg9duXIFX331FVpbW7Ug2RtrceHh4XaNfADw8uVL9Pb2agG5bdaoqipaWlqGba/xZAF7ONj7+/tRVFSE0tJSGI1GAssXevHiBX744QdUVFT4JDXnbs52YoODgzVLMhQenU6H2tpa9PT02LnPq1evQhTHvpVAURTo9XqIooj6+np89913uHPnzqRZ0Pb74J23CZeVlUGv1/tkYBljiImJwb59+xz6sYqKitDQ0GBXE7O1lKGhoXjrrbcQHByMuro6NDc3e81qDTcWycnJyMnJwcyZMwksTyf72bNnKC4uRmdnp0PfubcmioMiiiI+//xzrf7F1d3djcOHD6O3t1dbQLYFR1VViKIIs9mswecLqGzHRRAEbN26FWlpaQSWO5IkSdvMwAfS3bqUJ+/56aefYv78+Xbvo6oqjEYjzp07h5s3b2JwcFDLQLkL5G7LarU6xGm+sFo6nQ6KomDBggXIzc3FjBkzCCxnT2N7ezuOHz+uxS7j+d6zZ89GYWGhXWuLLSAWiwVtbW24ceMGGhoaMDAwoJU4eP1sPGMgDtnmzZuxZMkSv4q//AYsWZZx7tw5XL9+3a6XaTwniTGGrKws5OTkaLHW0GIpd51WqxXPnz9HXV0dqqqqfBZXufKZFUXBnDlzsG3bNr+JvfwCrNbWVpSWlqKrq0ubTFcXc30xSStXrkReXp5dvGUL+dDP1dfXh4qKCtTU1EAUxXF/IHhWCwDr16/HqlWrJtx6TShYVqsVf//9N6qrq7WMzx8WYRljiIiIwIYNG5CSkmIH03ATxuOsP//8E5WVlRMyqfzBkGUZSUlJyM/PR2Rk5NQCSxAEPHjwAMXFxRgYGIDFYvFK7cfbk2S1WhEbG4vVq1cjNTXVrjJv+7O21u7o0aMTUi0fmjUPDg5i48aNyMjImJB26HEHy2g0oqqqCv/++6/Wv8SXSZy1+Y7H5PCSga311Ol0MBqNWLBgAdLT0zFnzhzExcU5TKaqqnj69Cm+/vpru+1k4/1A2MIfFRWF/Px8xMbGjm8yNF5gMcbQ3NyMkpISv12e4IDbQmUbkNvu6ElLS0NeXh6mT59uBxZjDAcOHEBXV5dfuHS+5rlmzRq8/fbb4+YZxgUsk8mE06dPo7Gx0W8b2RRFQXx8POLj4/HixQs0Nzc7TMLQAD46Ohr79+/XXA3f8lVcXIxr1675jUvngM2YMQM7d+5EXFycz99b9PUXa2xsxMmTJ+325PlVIY8xSJKErKwsbNy4UatHXblyBeXl5SP2riuKgsePH+PRo0eYN2+eZt34xgvbzHaiHqahGW1PTw+OHDmCNWvWYO3atT61Xj4rvPT19eH48eM4duyYQ8ziT+Kubf369XY96ytXrhyxk5NbJr1ej/7+/mH/3R/Fv9vFixdx6NAhPH78ePKAxRhDTU0Nvv32WzQ1NUEURbf7zycitgoKCrJzGzqdDuvWrRvVdVqtVkRFRTm4yt7eXvizGGPo6+vD999/j7Nnz0KSJP8Gq7u7G0VFRSgrK4PFYtEGmncF+FvLB68/DQ4O4smTJ9qfuUtbsWIFoqOjoSiKXfswf/KXLl3qEK8oioI7d+44bLbwB/GeMv7w6PV6XL9+HQcOHMCDBw+8Oj+Ctyboxo0bOHToEJqbmyfVIRiMMQQFBaGystJhW7zBYMBHH32E1NRUmEwmbWu+xWLBm2++iZ07dzqAc/fuXQwMDEyq7282m/HTTz/h7NmzGBwcnPiskDGGrq4ulJeX49GjR3YB7GQZVKvVCr1eD0mS8PHHH2PRokXD/mxPTw+ePXsGRVGQmJio7Yy2rRtZLBYcOnQIHR0d475uOBbxRXQ+b7t27UJycvKY5tFjsBRFwY0bN1BRUWFXfZ6s4u05e/fuRWxsrENmNVIgzAdfkiScOHECt27dcvvwNn+MORcuXIjc3FyPTyj0CKzOzk6UlJSgra3NL2OnsQ7q7t27kZycbNfnPhJcqqqit7cXx48fx8OHD50COZkeNADYvn07UlJS3N955A5YiqKguroa1dXVdssZ492H5KtA3vb7JCYmIiMjAykpKXZlB/7vANDR0YGamhpcunTJoWY02a23bfIxb9487Nixw61lKpfBam9vR3FxMbq6ugICJFcg4w9TXFwcCgsLtYJiVVUVLl26hOfPn8NgMGhxZSCOCc+GGWPIycnBihUrXIq9RFforaqq0g4b89cKurefWF524F2tvKedP2T9/f3adv5Alm0MeebMGdy7dw/btm1zar2cpi6NjY04f/68VuMZ70a2iZBtLYuDc+bMGbS2tqK2thY3b97UtvMHSkw1WszJj3YCgJaWFpSWljr9vqKzgtrly5e1/7fNhgJZttu7+ENUW1uLq1evaks5HMCpYLH4Q8YLxLdv30Z3dzfCw8M9s1iqquLu3buTqibjK9AEQUBISIhfNSRORL1Lp9NBr9ejs7PTc1fIGENCQoLDQRlTSUPPIp2KR2sPHQtVVREWFuY5WIqiaK2tU3lASfaKjIx02tPl1Melp6dr/UakqS0eEhUUFDj1YC7VsRRFQVNTEx4+fAiTyRTQWRDJ0f3x7DAmJgaLFy9GUFCQ899zd0mHgJq6cifOFn354qQp7DZpCEgEFonAIk1t+ayM/N9//2kHplHA739BuO22N1/EzT4Fi/cpUcDvnxoYGEBmZubkslj8ySCo/NNiKYri0/2Pgi8/PLlA/5Wv54aCdxKBRSKwSAQWiTRFwOJZiyRJ2gl7VqtVO1aSH9rBf9YXga3t9idZlmE0GjEwMGB3ljs/x8Gbn2PoeRfAq2MfLRYLLBaL9v6Kokz4CYgTVm4Yi3gL7Nq1axEfH4/o6GgYDAZIkoSXL1+itbUV//zzD3p7e71+GwSH+vXXX0d6ejpmzZqlXX5pMpnQ3t6Ox48fo6qqyuvZFS8B6PV6ZGZmYu7cuZg9ezYMBgNkWUZfXx/a2tpw/fp1PHz4EAaDwS87W312ot/58+dx+fJlt54o29tMN23ahFWrVo0KDGMMdXV1KC8v1+oyY7kIk28YiIqKQl5eHpKSkkZ9rb6+PlRXV2ubLMaSxtueepydnY01a9bAYDCM7GoEAU1NTTh9+jR6enrcKvPw+qLJZMIXX3wR2K6QT2pQUBAKCwuRkZHh1AqpqoqlS5di//79iIiI0A72H8tnSElJwSeffIKEhASngIaFhSE3Nxd5eXnatSyeuCZ+1oPVasWuXbvwzjvvjAoVt2zz589HYWEhkpKStPHzlz2ffgWWoijYs2eP22dkzpw5E3v27EFoaKjHLlEQBCQkJCA/P9+ta+v4OVrr1q3zON7hrnz37t1ITU11L5YRRXz44YeIi4uDJEke3zAbsGAJgoCcnBy7i77dhSs3N9fu8iRX3BKPT0RRREFBgUdPvKqqyMzMRFpa2rD3GzqTXq/HG2+8gcWLF3s8dtu2bYPZbCaLNZwrWL58+ZheZ9GiRUhMTHSI2UabEO6+srKyxnQ2O2MM7733nl3W6KokSUJGRsaYMryoqCisX7/eJ8c+TlqwVFXFu+++65XNoNnZ2dpZV84miqfsZrN5zFADr67/TU5Odvv30tLSxnw9iaqqWLJkCVmsoYPirbPHY2Ji3LrkiTGGRYsWee0miXnz5rkd56WlpXmlHhUTE+ORxQxYsIaePjwWhYSEuLQ9ydYdjnYGgSdWyxVIbO/f8eZlSp7GaQEbvDtLr92Jdbibc7Vu5q33BoBp06a59N621X1vngfhL7et+lW5wZtgueKOePDuzbhEEASXAuhAOPlvUoA1kRkpicAiEVgkAotEIrBIBBaJwCKRCCwSgUUisEgkAotEYJEILBKJwCIRWCQCi0QisEgEFonAIpEILBKBRSKwSCQCi0RgkQgsEonAIhFYJAKLRCKwSAQWicAikQgsEoFFIrBIJAKLRGCRCCwSyT2JU/nL++slkgTWKGKMacdSOzuZ2BcXObp61ro3L9DksLpyUZPtOe++elhG+gx8rPkdRr74HD4DS5ZlDRhnH9ybX47f/OUKWIIgwGKxeHxx5nCyWq0uX+3GL+/0NljO7mzkt2KYzWafWW2f3bDKB9fVD+7N2xkkSXILVsaY1y4R4HdIuyOdTuc1i+0urN4c93EBi0RZIYlEYJEILBKVG0YPBnt7e72evZAmpxhjCA0NdXoVn+gsHT9x4gTq6+vpliySBlZwcDD279+PsLAwz8BSVRU1NTUIDQ2lESXZebFnz56NCpbTGItf2k3LHySvxVgcJkVRIIoixVnkBrWqvTNDIzp7IVmWodPpXL4VnhT4cLmytusUrOXLl+P27dvkCkkaTAaDAbGxsaP/rLMlHUVR0NPTQ26QpCksLMxpuYHWCkk+EVXeSb7PCs1ms102SCK5I51OB71e/3+wuru7cfDgQfT390MQBK/1JpGmmPsTBOzcuRPLli17BVZbWxsYY4iIiIAsy2SxSB6roaEB6enpr8BSVRU6nU6rT1C9iuSpePcsBe8k3wXv3PXxqiqJ5IlsvZ0IAOHh4ZBlGYIgaIvOJJK7UhQF8fHxr5b/TCaTyhhDW1sbTCYTjQ5pTFlhQkICRFGkyjvJN/ofuz++mC7FjXAAAAAASUVORK5CYII=',
  orgName: 'Fintellia Microfinance Bank Limited',
}
export const triggerTypes = [
  { label: 'Automatic', value: 'Automatic' },
  { label: 'Managed by User', value: 'Managed by User' },
]
export const countries = [
  {
    name: 'Nigeria',
    states: [
      {
        state: 'Adamawa',
        alias: 'adamawa',
        lgas: [
          'Demsa',
          'Fufure',
          'Ganye',
          'Gayuk',
          'Gombi',
          'Grie',
          'Hong',
          'Jada',
          'Larmurde',
          'Madagali',
          'Maiha',
          'Mayo Belwa',
          'Michika',
          'Mubi North',
          'Mubi South',
          'Numan',
          'Shelleng',
          'Song',
          'Toungo',
          'Yola North',
          'Yola South',
        ],
      },
      {
        state: 'Akwa Ibom',
        alias: 'akwa_ibom',
        lgas: [
          'Abak',
          'Eastern Obolo',
          'Eket',
          'Esit Eket',
          'Essien Udim',
          'Etim Ekpo',
          'Etinan',
          'Ibeno',
          'Ibesikpo Asutan',
          'Ibiono-Ibom',
          'Ikot Abasi',
          'Ika',
          'Ikono',
          'Ikot Ekpene',
          'Ini',
          'Mkpat-Enin',
          'Itu',
          'Mbo',
          'Nsit-Atai',
          'Nsit-Ibom',
          'Nsit-Ubium',
          'Obot Akara',
          'Okobo',
          'Onna',
          'Oron',
          'Udung-Uko',
          'Ukanafun',
          'Oruk Anam',
          'Uruan',
          'Urue-Offong/Oruko',
          'Uyo',
        ],
      },
      {
        state: 'Anambra',
        alias: 'anambra',
        lgas: [
          'Aguata',
          'Anambra East',
          'Anaocha',
          'Awka North',
          'Anambra West',
          'Awka South',
          'Ayamelum',
          'Dunukofia',
          'Ekwusigo',
          'Idemili North',
          'Idemili South',
          'Ihiala',
          'Njikoka',
          'Nnewi North',
          'Nnewi South',
          'Ogbaru',
          'Onitsha North',
          'Onitsha South',
          'Orumba North',
          'Orumba South',
          'Oyi',
        ],
      },
      {
        state: 'Ogun',
        alias: 'ogun',
        lgas: [
          'Abeokuta North',
          'Abeokuta South',
          'Ado-Odo/Ota',
          'Egbado North',
          'Ewekoro',
          'Egbado South',
          'Ijebu North',
          'Ijebu East',
          'Ifo',
          'Ijebu Ode',
          'Ijebu North East',
          'Imeko Afon',
          'Ikenne',
          'Ipokia',
          'Odeda',
          'Obafemi Owode',
          'Odogbolu',
          'Remo North',
          'Ogun Waterside',
          'Shagamu',
        ],
      },
      {
        state: 'Ondo',
        alias: 'ondo',
        lgas: [
          'Akoko North-East',
          'Akoko North-West',
          'Akoko South-West',
          'Akoko South-East',
          'Akure North',
          'Akure South',
          'Ese Odo',
          'Idanre',
          'Ifedore',
          'Ilaje',
          'Irele',
          'Ile Oluji/Okeigbo',
          'Odigbo',
          'Okitipupa',
          'Ondo West',
          'Ose',
          'Ondo East',
          'Owo',
        ],
      },
      {
        state: 'Rivers',
        alias: 'rivers',
        lgas: [
          'Abua/Odual',
          'Ahoada East',
          'Ahoada West',
          'Andoni',
          'Akuku-Toru',
          'Asari-Toru',
          'Bonny',
          'Degema',
          'Emuoha',
          'Eleme',
          'Ikwerre',
          'Etche',
          'Gokana',
          'Khana',
          'Obio/Akpor',
          'Ogba/Egbema/Ndoni',
          'Ogu/Bolo',
          'Okrika',
          'Omuma',
          'Opobo/Nkoro',
          'Oyigbo',
          'Port Harcourt',
          'Tai',
        ],
      },
      {
        state: 'Bauchi',
        alias: 'bauchi',
        lgas: [
          'Alkaleri',
          'Bauchi',
          'Bogoro',
          'Damban',
          'Darazo',
          'Dass',
          'Gamawa',
          'Ganjuwa',
          'Giade',
          'Itas/Gadau',
          "Jama'are",
          'Katagum',
          'Kirfi',
          'Misau',
          'Ningi',
          'Shira',
          'Tafawa Balewa',
          'Toro',
          'Warji',
          'Zaki',
        ],
      },
      {
        state: 'Benue',
        alias: 'benue',
        lgas: [
          'Agatu',
          'Apa',
          'Ado',
          'Buruku',
          'Gboko',
          'Guma',
          'Gwer East',
          'Gwer West',
          'Katsina-Ala',
          'Konshisha',
          'Kwande',
          'Logo',
          'Makurdi',
          'Obi',
          'Ogbadibo',
          'Ohimini',
          'Oju',
          'Okpokwu',
          'Oturkpo',
          'Tarka',
          'Ukum',
          'Ushongo',
          'Vandeikya',
        ],
      },
      {
        state: 'Borno',
        alias: 'borno',
        lgas: [
          'Abadam',
          'Askira/Uba',
          'Bama',
          'Bayo',
          'Biu',
          'Chibok',
          'Damboa',
          'Dikwa',
          'Guzamala',
          'Gubio',
          'Hawul',
          'Gwoza',
          'Jere',
          'Kaga',
          'Kala/Balge',
          'Konduga',
          'Kukawa',
          'Kwaya Kusar',
          'Mafa',
          'Magumeri',
          'Maiduguri',
          'Mobbar',
          'Marte',
          'Monguno',
          'Ngala',
          'Nganzai',
          'Shani',
        ],
      },
      {
        state: 'Bayelsa',
        alias: 'bayelsa',
        lgas: [
          'Brass',
          'Ekeremor',
          'Kolokuma/Opokuma',
          'Nembe',
          'Ogbia',
          'Sagbama',
          'Southern Ijaw',
          'Yenagoa',
        ],
      },
      {
        state: 'Cross River',
        alias: 'cross_river',
        lgas: [
          'Abi',
          'Akamkpa',
          'Akpabuyo',
          'Bakassi',
          'Bekwarra',
          'Biase',
          'Boki',
          'Calabar Municipal',
          'Calabar South',
          'Etung',
          'Ikom',
          'Obanliku',
          'Obubra',
          'Obudu',
          'Odukpani',
          'Ogoja',
          'Yakuur',
          'Yala',
        ],
      },
      {
        state: 'Delta',
        alias: 'delta',
        lgas: [
          'Aniocha North',
          'Aniocha South',
          'Bomadi',
          'Burutu',
          'Ethiope West',
          'Ethiope East',
          'Ika North East',
          'Ika South',
          'Isoko North',
          'Isoko South',
          'Ndokwa East',
          'Ndokwa West',
          'Okpe',
          'Oshimili North',
          'Oshimili South',
          'Patani',
          'Sapele',
          'Udu',
          'Ughelli North',
          'Ukwuani',
          'Ughelli South',
          'Uvwie',
          'Warri North',
          'Warri South',
          'Warri South West',
        ],
      },
      {
        state: 'Ebonyi',
        alias: 'ebonyi',
        lgas: [
          'Abakaliki',
          'Afikpo North',
          'Ebonyi',
          'Afikpo South',
          'Ezza North',
          'Ikwo',
          'Ezza South',
          'Ivo',
          'Ishielu',
          'Izzi',
          'Ohaozara',
          'Ohaukwu',
          'Onicha',
        ],
      },
      {
        state: 'Edo',
        alias: 'edo',
        lgas: [
          'Akoko-Edo',
          'Egor',
          'Esan Central',
          'Esan North-East',
          'Esan South-East',
          'Esan West',
          'Etsako Central',
          'Etsako East',
          'Etsako West',
          'Igueben',
          'Ikpoba Okha',
          'Orhionmwon',
          'Oredo',
          'Ovia North-East',
          'Ovia South-West',
          'Owan East',
          'Owan West',
          'Uhunmwonde',
        ],
      },
      {
        state: 'Ekiti',
        alias: 'ekiti',
        lgas: [
          'Ado Ekiti',
          'Efon',
          'Ekiti East',
          'Ekiti South-West',
          'Ekiti West',
          'Emure',
          'Gbonyin',
          'Ido Osi',
          'Ijero',
          'Ikere',
          'Ilejemeje',
          'Irepodun/Ifelodun',
          'Ikole',
          'Ise/Orun',
          'Moba',
          'Oye',
        ],
      },
      {
        state: 'Enugu',
        alias: 'enugu',
        lgas: [
          'Awgu',
          'Aninri',
          'Enugu East',
          'Enugu North',
          'Ezeagu',
          'Enugu South',
          'Igbo Etiti',
          'Igbo Eze North',
          'Igbo Eze South',
          'Isi Uzo',
          'Nkanu East',
          'Nkanu West',
          'Nsukka',
          'Udenu',
          'Oji River',
          'Uzo Uwani',
          'Udi',
        ],
      },
      {
        state: 'Federal Capital Territory',
        alias: 'abuja',
        lgas: [
          'Abaji',
          'Bwari',
          'Gwagwalada',
          'Kuje',
          'Kwali',
          'Municipal Area Council',
        ],
      },
      {
        state: 'Gombe',
        alias: 'gombe',
        lgas: [
          'Akko',
          'Balanga',
          'Billiri',
          'Dukku',
          'Funakaye',
          'Gombe',
          'Kaltungo',
          'Kwami',
          'Nafada',
          'Shongom',
          'Yamaltu/Deba',
        ],
      },
      {
        state: 'Jigawa',
        alias: 'jigawa',
        lgas: [
          'Auyo',
          'Babura',
          'Buji',
          'Biriniwa',
          'Birnin Kudu',
          'Dutse',
          'Gagarawa',
          'Garki',
          'Gumel',
          'Guri',
          'Gwaram',
          'Gwiwa',
          'Hadejia',
          'Jahun',
          'Kafin Hausa',
          'Kazaure',
          'Kiri Kasama',
          'Kiyawa',
          'Kaugama',
          'Maigatari',
          'Malam Madori',
          'Miga',
          'Sule Tankarkar',
          'Roni',
          'Ringim',
          'Yankwashi',
          'Taura',
        ],
      },
      {
        state: 'Oyo',
        alias: 'oyo',
        lgas: [
          'Afijio',
          'Akinyele',
          'Atiba',
          'Atisbo',
          'Egbeda',
          'Ibadan North',
          'Ibadan North-East',
          'Ibadan North-West',
          'Ibadan South-East',
          'Ibarapa Central',
          'Ibadan South-West',
          'Ibarapa East',
          'Ido',
          'Ibarapa North',
          'Irepo',
          'Iseyin',
          'Itesiwaju',
          'Iwajowa',
          'Kajola',
          'Lagelu',
          'Ogbomosho North',
          'Ogbomosho South',
          'Ogo Oluwa',
          'Olorunsogo',
          'Oluyole',
          'Ona Ara',
          'Orelope',
          'Ori Ire',
          'Oyo',
          'Oyo East',
          'Saki East',
          'Saki West',
          'Surulere Oyo State',
        ],
      },
      {
        state: 'Imo',
        alias: 'imo',
        lgas: [
          'Aboh Mbaise',
          'Ahiazu Mbaise',
          'Ehime Mbano',
          'Ezinihitte',
          'Ideato North',
          'Ideato South',
          'Ihitte/Uboma',
          'Ikeduru',
          'Isiala Mbano',
          'Mbaitoli',
          'Isu',
          'Ngor Okpala',
          'Njaba',
          'Nkwerre',
          'Nwangele',
          'Obowo',
          'Oguta',
          'Ohaji/Egbema',
          'Okigwe',
          'Orlu',
          'Orsu',
          'Oru East',
          'Oru West',
          'Owerri Municipal',
          'Owerri North',
          'Unuimo',
          'Owerri West',
        ],
      },
      {
        state: 'Kaduna',
        alias: 'kaduna',
        lgas: [
          'Birnin Gwari',
          'Chikun',
          'Giwa',
          'Ikara',
          'Igabi',
          'Jaba',
          "Jema'a",
          'Kachia',
          'Kaduna North',
          'Kaduna South',
          'Kagarko',
          'Kajuru',
          'Kaura',
          'Kauru',
          'Kubau',
          'Kudan',
          'Lere',
          'Makarfi',
          'Sabon Gari',
          'Sanga',
          'Soba',
          'Zangon Kataf',
          'Zaria',
        ],
      },
      {
        state: 'Kebbi',
        alias: 'kebbi',
        lgas: [
          'Aleiro',
          'Argungu',
          'Arewa Dandi',
          'Augie',
          'Bagudo',
          'Birnin Kebbi',
          'Bunza',
          'Dandi',
          'Fakai',
          'Gwandu',
          'Jega',
          'Kalgo',
          'Koko/Besse',
          'Maiyama',
          'Ngaski',
          'Shanga',
          'Suru',
          'Sakaba',
          'Wasagu/Danko',
          'Yauri',
          'Zuru',
        ],
      },
      {
        state: 'Kano',
        alias: 'kano',
        lgas: [
          'Ajingi',
          'Albasu',
          'Bagwai',
          'Bebeji',
          'Bichi',
          'Bunkure',
          'Dala',
          'Dambatta',
          'Dawakin Kudu',
          'Dawakin Tofa',
          'Doguwa',
          'Fagge',
          'Gabasawa',
          'Garko',
          'Garun Mallam',
          'Gezawa',
          'Gaya',
          'Gwale',
          'Gwarzo',
          'Kabo',
          'Kano Municipal',
          'Karaye',
          'Kibiya',
          'Kiru',
          'Kumbotso',
          'Kunchi',
          'Kura',
          'Madobi',
          'Makoda',
          'Minjibir',
          'Nasarawa',
          'Rano',
          'Rimin Gado',
          'Rogo',
          'Shanono',
          'Takai',
          'Sumaila',
          'Tarauni',
          'Tofa',
          'Tsanyawa',
          'Tudun Wada',
          'Ungogo',
          'Warawa',
          'Wudil',
        ],
      },
      {
        state: 'Kogi',
        alias: 'kogi',
        lgas: [
          'Ajaokuta',
          'Adavi',
          'Ankpa',
          'Bassa',
          'Dekina',
          'Ibaji',
          'Idah',
          'Igalamela Odolu',
          'Ijumu',
          'Kogi',
          'Kabba/Bunu',
          'Lokoja',
          'Ofu',
          'Mopa Muro',
          'Ogori/Magongo',
          'Okehi',
          'Okene',
          'Olamaboro',
          'Omala',
          'Yagba East',
          'Yagba West',
        ],
      },
      {
        state: 'Osun',
        alias: 'osun',
        lgas: [
          'Aiyedire',
          'Atakunmosa West',
          'Atakunmosa East',
          'Aiyedaade',
          'Boluwaduro',
          'Boripe',
          'Ife East',
          'Ede South',
          'Ife North',
          'Ede North',
          'Ife South',
          'Ejigbo',
          'Ife Central',
          'Ifedayo',
          'Egbedore',
          'Ila',
          'Ifelodun',
          'Ilesa East',
          'Ilesa West',
          'Irepodun',
          'Irewole',
          'Isokan',
          'Iwo',
          'Obokun',
          'Odo Otin',
          'Ola Oluwa',
          'Olorunda',
          'Oriade',
          'Orolu',
          'Osogbo',
        ],
      },
      {
        state: 'Sokoto',
        alias: 'sokoto',
        lgas: [
          'Gudu',
          'Gwadabawa',
          'Illela',
          'Isa',
          'Kebbe',
          'Kware',
          'Rabah',
          'Sabon Birni',
          'Shagari',
          'Silame',
          'Sokoto North',
          'Sokoto South',
          'Tambuwal',
          'Tangaza',
          'Tureta',
          'Wamako',
          'Wurno',
          'Yabo',
          'Binji',
          'Bodinga',
          'Dange Shuni',
          'Goronyo',
          'Gada',
        ],
      },
      {
        state: 'Plateau',
        alias: 'plateau',
        lgas: [
          'Bokkos',
          'Barkin Ladi',
          'Bassa',
          'Jos East',
          'Jos North',
          'Jos South',
          'Kanam',
          'Kanke',
          'Langtang South',
          'Langtang North',
          'Mangu',
          'Mikang',
          'Pankshin',
          "Qua'an Pan",
          'Riyom',
          'Shendam',
          'Wase',
        ],
      },
      {
        state: 'Taraba',
        alias: 'taraba',
        lgas: [
          'Ardo Kola',
          'Bali',
          'Donga',
          'Gashaka',
          'Gassol',
          'Ibi',
          'Jalingo',
          'Karim Lamido',
          'Kumi',
          'Lau',
          'Sardauna',
          'Takum',
          'Ussa',
          'Wukari',
          'Yorro',
          'Zing',
        ],
      },
      {
        state: 'Yobe',
        alias: 'yobe',
        lgas: [
          'Bade',
          'Bursari',
          'Damaturu',
          'Fika',
          'Fune',
          'Geidam',
          'Gujba',
          'Gulani',
          'Jakusko',
          'Karasuwa',
          'Machina',
          'Nangere',
          'Nguru',
          'Potiskum',
          'Tarmuwa',
          'Yunusari',
          'Yusufari',
        ],
      },
      {
        state: 'Zamfara',
        alias: 'zamfara',
        lgas: [
          'Anka',
          'Birnin Magaji/Kiyaw',
          'Bakura',
          'Bukkuyum',
          'Bungudu',
          'Gummi',
          'Gusau',
          'Kaura Namoda',
          'Maradun',
          'Shinkafi',
          'Maru',
          'Talata Mafara',
          'Tsafe',
          'Zurmi',
        ],
      },
      {
        state: 'Lagos',
        alias: 'lagos',
        lgas: [
          'Agege',
          'Ajeromi-Ifelodun',
          'Alimosho',
          'Amuwo-Odofin',
          'Badagry',
          'Apapa',
          'Epe',
          'Eti Osa',
          'Ibeju-Lekki',
          'Ifako-Ijaiye',
          'Ikeja',
          'Ikorodu',
          'Kosofe',
          'Lagos Island',
          'Mushin',
          'Lagos Mainland',
          'Ojo',
          'Oshodi-Isolo',
          'Shomolu',
          'Surulere Lagos State',
        ],
      },
      {
        state: 'Katsina',
        alias: 'katsina',
        lgas: [
          'Bakori',
          'Batagarawa',
          'Batsari',
          'Baure',
          'Bindawa',
          'Charanchi',
          'Danja',
          'Dandume',
          'Dan Musa',
          'Daura',
          'Dutsi',
          'Dutsin Ma',
          'Faskari',
          'Funtua',
          'Ingawa',
          'Jibia',
          'Kafur',
          'Kaita',
          'Kankara',
          'Kankia',
          'Katsina',
          'Kurfi',
          'Kusada',
          "Mai'Adua",
          'Malumfashi',
          'Mani',
          'Mashi',
          'Matazu',
          'Musawa',
          'Rimi',
          'Sabuwa',
          'Safana',
          'Sandamu',
          'Zango',
        ],
      },
      {
        state: 'Kwara',
        alias: 'kwara',
        lgas: [
          'Asa',
          'Baruten',
          'Edu',
          'Ilorin East',
          'Ifelodun',
          'Ilorin South',
          'Ekiti Kwara State',
          'Ilorin West',
          'Irepodun',
          'Isin',
          'Kaiama',
          'Moro',
          'Offa',
          'Oke Ero',
          'Oyun',
          'Pategi',
        ],
      },
      {
        state: 'Nasarawa',
        alias: 'nasarawa',
        lgas: [
          'Akwanga',
          'Awe',
          'Doma',
          'Karu',
          'Keana',
          'Keffi',
          'Lafia',
          'Kokona',
          'Nasarawa Egon',
          'Nasarawa',
          'Obi',
          'Toto',
          'Wamba',
        ],
      },
      {
        state: 'Niger',
        alias: 'niger',
        lgas: [
          'Agaie',
          'Agwara',
          'Bida',
          'Borgu',
          'Bosso',
          'Chanchaga',
          'Edati',
          'Gbako',
          'Gurara',
          'Katcha',
          'Kontagora',
          'Lapai',
          'Lavun',
          'Mariga',
          'Magama',
          'Mokwa',
          'Mashegu',
          'Moya',
          'Paikoro',
          'Rafi',
          'Rijau',
          'Shiroro',
          'Suleja',
          'Tafa',
          'Wushishi',
        ],
      },
      {
        state: 'Abia',
        alias: 'abia',
        lgas: [
          'Aba North',
          'Arochukwu',
          'Aba South',
          'Bende',
          'Isiala Ngwa North',
          'Ikwuano',
          'Isiala Ngwa South',
          'Isuikwuato',
          'Obi Ngwa',
          'Ohafia',
          'Osisioma',
          'Ugwunagbo',
          'Ukwa East',
          'Ukwa West',
          'Umuahia North',
          'Umuahia South',
          'Umu Nneochi',
        ],
      },
    ],
  },
  {
    name: 'Cameroon',
    states: [
      {
        state: 'Adamawa',
        alias: 'adamawa_cameroon',
        lgas: ['Ngaoundéré', 'Banyo', 'Tibati', 'Meiganga'],
      },
      {
        state: 'Centre',
        alias: 'centre_cameroon',
        lgas: [
          'Yaoundé',
          'Mbalmayo',
          'Nanga Eboko',
          'Obala',
          'Akonolinga',
          'Bafia',
          'Eséka',
          'Mfou',
        ],
      },
      {
        state: 'East',
        alias: 'east_cameroon',
        lgas: [
          'Bertoua',
          'Batouri',
          'Yokadouma',
          'Abong-Mbang',
          'Garoua-Boulai',
        ],
      },
      {
        state: 'Far North',
        alias: 'far_north_cameroon',
        lgas: [
          'Maroua',
          'Mokolo',
          'Kaélé',
          'Yagoua',
          'Mora',
          'Kousseri',
          'Mindif',
        ],
      },
      {
        state: 'Littoral',
        alias: 'littoral_cameroon',
        lgas: [
          'Douala',
          'Edea',
          'Nkongsamba',
          'Loum',
          'Dibombari',
          'Manjo',
          'Melong',
        ],
      },
      {
        state: 'North',
        alias: 'north_cameroon',
        lgas: ['Garoua', 'Guider', 'Poli', 'Tcholliré'],
      },
      {
        state: 'North-West',
        alias: 'north_west_cameroon',
        lgas: [
          'Bamenda',
          'Ndop',
          'Kumbo',
          'Wum',
          'Fundong',
          'Bafut',
          'Njinikom',
        ],
      },
      {
        state: 'South',
        alias: 'south_cameroon',
        lgas: ['Ebolowa', 'Sangmélima', 'Kribi', 'Ambam', 'Meyomessala'],
      },
      {
        state: 'South-West',
        alias: 'south_west_cameroon',
        lgas: [
          'Buea',
          'Limbe',
          'Kumba',
          'Mamfe',
          'Tiko',
          'Muyuka',
          'Mutengene',
        ],
      },
      {
        state: 'West',
        alias: 'west_cameroon',
        lgas: [
          'Bafoussam',
          'Dschang',
          'Mbouda',
          'Foumban',
          'Bangangté',
          'Bafang',
          'Kekem',
        ],
      },
    ],
  },
]

export const employmentStatus = [
  { label: 'Salaried', value: 'Salaried' },
  { label: 'Self Employed', value: 'SelfEmployed' },
  { label: 'Unemployed', value: 'Unemployed' },
  { label: 'Employed', value: 'Employed' },
]

export const sectorList = [
  { label: 'Education', value: 'Education' },
  { label: 'Health Care', value: 'Healthcare' },
  { label: 'Renewable Energy', value: 'RenewableEnergy' },
  { label: 'Mobility', value: 'Mobility' },
  { label: 'Home Improvement', value: 'HomeImprovement' },
  { label: 'Digital Inclusion', value: 'DigitalInclusion' },
]

export const chargeType = [
  { label: 'Percentage', value: 'Percentage' },
  { label: 'Flat Amount', value: 'FlatAmount' },
]

export const chargeFrequency = [
  { label: 'Daily', value: 'Daily' },
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Monthly', value: 'Monthly' },
]

export const statusList = [
  { label: 'Liquidated', value: 'Liquidated' },
  { label: 'Active', value: 'Active' },
  { label: 'Inactive', value: 'Inactive' },
]

export const prepaymentCategory = [
  { label: 'Rent Prepayment', value: 'Rent Prepayment' },
  { label: 'Interest Prepayment', value: 'Interest Prepayment' },
  { label: 'Insurance Prepayment', value: 'Insurance Prepayment' },
  { label: 'Tax Prepayment', value: 'Tax Prepayment' },
  { label: 'Other Prepayment', value: 'Other Prepayment' },
]

export const preferredFonts = [
  { label: 'Inter', value: 'Inter' },
  { label: 'Satoshi', value: 'Satoshi' },
  { label: 'Public Sans', value: 'Public Sans' },
  { label: 'Roboto', value: 'Roboto' },
  { label: 'Open Sans', value: 'Open Sans' },
  { label: 'Montserrat', value: 'Montserrat' },
  { label: 'Lato', value: 'Lato' },
  // { label: 'Source Sans 3', value: 'Source Sans 3' },
  { label: 'Merriweather', value: 'Merriweather' },
  { label: 'Space Mono', value: 'Space Mono' },
  { label: 'Poppins', value: 'Poppins' },
  { label: 'Fira Sans', value: 'Fira Sans' },
  { label: 'IBM Plex Sans', value: 'IBM Plex Sans' },
  // { label: 'Ubuntu', value: 'Ubuntu' },
  { label: 'Lora', value: 'Lora' },
  { label: 'Playfair Display', value: 'Playfair Display' },
  { label: 'Oswald', value: 'Oswald' },
  // { label: 'PT Sans', value: 'PT Sans' },
  { label: 'Karla', value: 'Karla' },
  { label: 'Rubik', value: 'Rubik' },
  { label: 'Bricolage Grotesque', value: 'Bricolage Grotesque' },
  { label: 'Jost', value: 'Jost' },
].sort((a, b) => (a.label === b.label ? 0 : a.label < b.label ? -1 : 1))

export const preferredLoginOptions = [
  { label: 'Design A', value: 'template-v1' },
  { label: 'Design B', value: 'template-v2' },
]

export const isThirdParty = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
]
